import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUndo = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 27,
	height: 26,
	viewBox: "0 0 27 26",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#000",
		fillRule: "evenodd",
		d: "M8.09 6.672c.786.773 1.559 1.528 2.325 2.29.575.573.4 1.47-.352 1.784a1.2 1.2 0 0 1-.44.078q-3.757.006-7.513.003c-.646 0-1.092-.427-1.117-1.076C.985 9.56.99 9.369.99 9.178v-6.96c-.001-.457.192-.797.591-1.017.412-.227.933-.136 1.27.203Q3.909 2.46 4.968 3.51c.022.023.048.042.05.044.545-.426 1.06-.868 1.614-1.254C8.08 1.29 9.67.58 11.406.26c4.825-.885 8.934.482 12.272 4.065 1.819 1.952 2.891 4.292 3.22 6.945.45 3.652-.434 6.95-2.744 9.835-1.559 1.949-3.517 3.35-5.875 4.181-1.11.391-2.258.611-3.433.685a12.93 12.93 0 0 1-7.233-1.634 12.7 12.7 0 0 1-3.57-2.958c-.234-.278-.222-.588.034-.846l2.188-2.2c.337-.34.673-.32.968.052 1.215 1.535 2.771 2.556 4.669 3.026 3.724.922 7.557-.678 9.55-3.974 1.02-1.689 1.372-3.521 1.166-5.478-.357-3.387-2.935-6.398-6.238-7.314a8.75 8.75 0 0 0-3.851-.208A8.46 8.46 0 0 0 8.75 6.09c-.188.144-.364.304-.544.458-.03.025-.054.056-.117.123"
	})
});
export default SvgUndo;
